import React, { useEffect, useRef, useState } from "react"
import { FaChevronDown, FaChevronUp } from "react-icons/fa"

import classes from "./dropdown.module.scss"

const Dropwdown = ({ value, options, placeholder, onChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef()
  const itemRef = useRef()

  console.log("value: ", value)

  const handleOutsideClick = e => {
    if (e.target.contains(dropdownRef.current)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick)
    return () => {
      document.removeEventListener("click", handleOutsideClick)
    }
  }, [])

  useEffect(() => {
    if (isOpen) {
      const activeItem = itemRef.current.querySelector(".active")
      itemRef.current.scrollTop = activeItem?.offsetTop - 72
    }
  }, [isOpen])

  return (
    <div ref={dropdownRef} className={classes.Container}>
      <button onClick={() => setIsOpen(!isOpen)} className={classes.Button}>
        {value || placeholder}
        {!isOpen ? <FaChevronDown /> : <FaChevronUp />}
      </button>
      {isOpen && (
        <div ref={itemRef} className={classes.List}>
          {options.map(opt => (
            <button
              key={opt.id}
              className={
                opt.name === value
                  ? `${classes.Item} ${classes.ItemActive}`
                  : classes.Item
              }
              onClick={() => {
                onChange(opt.value)
                setIsOpen(false)
              }}
            >
              {opt.name}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default Dropwdown
